import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { PowerSupplyOperationsReport, UserDetails } from '@psnb/psnb-api';
import { AccessLogService, AuthService, PowerSupplyOperationsService, PowerSupplyService } from '@psnb/services';
import { CommonService } from 'mobile/common/common.service';
import { SharedService } from '../datashared.service';
import { EditTestDurationRendererComponent } from './edit-test-duration-renderer.component';
import { SelftestconfirmDialogComponent } from './selftestconfirm-dialog/selftestconfirm-dialog.component';

@Component({
  selector: 'psnb-mobile-power-supply-selftestdata',
  templateUrl: './power-supply-selftestdata.component.html',
  styleUrls: ['./power-supply-selftestdata.component.scss']
})
export class PowerSupplySelftestdataComponent implements OnInit {
  searchText: string;
  // matcher = new MyErrorStateMatcher();
  userDetails: UserDetails;
  ipVal: any;
  headerMsg: string;
  private confirmDialog: MatDialogRef<SelftestconfirmDialogComponent>;
  private editTestDurationRendererComponent: MatDialogRef<EditTestDurationRendererComponent>;
  action: String;
  @Input() powerSupplyId: number;
  @Input() ip: string;
  @Input() macaddress: any;
  @Input() cmts: any;
  private gridApi;
  private gridColumnApi;
  public rowData: Array<PowerSupplyOperationsReport>;
  public context;
  public columnDefs;
  public defaultColDef;
  public isSelfTestStart: boolean;
  public user: string;
  public time: string;
  currentval: any;
  showTelemetryThreshold: boolean = true;
  telemetrynet: boolean = false;
  network: boolean = false;
  sharedData: any;
  lastRundate: any;
  lastRunDate: any;
  lastRunStatus: string;
  ipAddress: string;
  isSelfTestStartMsg: boolean;
  processedData: any;
  //resetcmhmsreset: boolean = false;
  cmKickStartBtn: boolean = false;
  remotestatus:any;
  remotestatustimer:any;
  inverterStatusVar: string = "";
  spinner : boolean = false;
  operationPerformed:any;
  psAlertShow : boolean;
  psSelfTestStartShow : boolean;
  psSelfTestStopShow : boolean;
  //hmResetShow : boolean;
  cmKickStartFlag: boolean = false;
  cmResetShow : boolean;
  testDurationShow : boolean;
  refreshShow : boolean;
  rmode:boolean;
  RModeStatus:any;
  runStatus:any;
  lastRunStatusTelemetry:any;
  constructor(
    private router: Router,
    private powerSupplyService: PowerSupplyService,
    private authService: AuthService,
    private route: ActivatedRoute,
    private ref: ChangeDetectorRef,
    private accessLogService: AccessLogService,
    public dialog: MatDialog,
    private powerSupplyOperationsSvc: PowerSupplyOperationsService,
    private sharedService: SharedService) {
    this.isSelfTestStart = false;
    this.isSelfTestStartMsg = false;
    //Get the mac address in query string - url
    this.route.queryParams
      .subscribe(params => {
        const url = window.location.href;
        if (url.includes('/telemetry-networkops')) {
          this.headerMsg = "Telemetry Data & Transponder Operations";
          this.telemetrynet = false;
        } else if (url.includes('/networkops')) {
          this.headerMsg = "Power Supply - Transponder Operations";
          this.network = true;
        }

        //this.powerSupplyId = params['powerSupplyId'];
        //this.ip = params['ip'];
        //this.ipAddress = this.ip;
       /* this.macaddress = params['macAddress'];
        if (this.macaddress != null && this.ip != null) {
          this.getOperationList(this.macaddress);
        }*/
        this.powerSupplyId = params['powerSupplyId'];
        if (this.powerSupplyId != null) {
          this.getOperationList(this.powerSupplyId);
        }
      });
  }

  ngOnInit(): void {
    //let userPermissions = this.authService.getDecryptConfig;
    let userPermissions = JSON.parse(localStorage.getItem('user-permissions'));
    userPermissions.forEach(element => {
      if(element.category === CommonService.TRANSPONDEROPSTAB && element.functionality === CommonService.TRANSPONDEROPSTABPSALERTBTN){
        if(element.permission === CommonService.ENABLED){
          this.psAlertShow = true;
        }
      }
      if(element.category === CommonService.TRANSPONDEROPSTAB && element.functionality === CommonService.TRANSPONDEROPSTABREMOTESELFTESTSTARTBTN){
        if(element.permission === CommonService.ENABLED){
          this.psSelfTestStartShow = true;
        }
      }
      if(element.category === CommonService.TRANSPONDEROPSTAB && element.functionality === CommonService.TRANSPONDEROPSTABREMOTESELFTESTSTOPBTN){
        if(element.permission === CommonService.ENABLED){
          this.psSelfTestStopShow = true;
        }
      }
      if(element.category === CommonService.TRANSPONDEROPSTAB && element.functionality === CommonService.TRANSPONDEROPSTABCMRESETBTN){
        if(element.permission === CommonService.ENABLED){
          this.cmResetShow = true;
        }
      }
      /*US2481218 : HMS Reset button remove no longer needed instead add CM Kickstart
      if(element.category === CommonService.TRANSPONDEROPSTAB && element.functionality === CommonService.TRANSPONDEROPSTABHMRESETBTN){
        if(element.permission === CommonService.ENABLED){
          this.hmResetShow = true;
        }
      }*/
      //US2481218 : Enabled permission for CM Kickstart
      if (element.category === CommonService.TRANSPONDEROPSTAB
        && element.functionality === CommonService.TRANSPONDEROPS_TAB_CM_KICKSTART_BTN) {
        if (element.permission === CommonService.ENABLED) {
          this.cmKickStartFlag = true;
        }
      }
      if(element.category === CommonService.TRANSPONDEROPSTAB && element.functionality === CommonService.TRANSPONDEROPSTABEDITTESTDURATIONBTN){
        if(element.permission === CommonService.ENABLED){
          this.testDurationShow = true;
        }
      }
      if(element.category === CommonService.TRANSPONDEROPSTAB && element.functionality === CommonService.TRANSPONDEROPSTABREFRESHDATABTN){
        if(element.permission === CommonService.ENABLED){
          this.refreshShow = true;
        }
      }
      if(element.category === CommonService.TRANSPONDEROPSTAB && element.functionality === CommonService.TRANSPONDEROPSRMODE){
        if(element.permission === CommonService.ENABLED){
          this.rmode = true;
        }
      }
    });
    //call the refresh
    this.sharedService.sharedsetDataTelemetryReload$
    .subscribe(sharedData => {
      if(sharedData == 'reload'){
        //self start button disabled when the genome api call status returned success
        this.isSelfTestStart = true;
        this.refreshOperation();
      }
    });

    this.sharedService.sharedData$.subscribe(sharedData => {
      this.sharedData = sharedData;
      this.powerSupplyId = this.sharedData['psId'];
      this.ip = this.sharedData['transponderIp'];
      this.ipAddress = this.ip;
      this.cmts = this.sharedData['cmts'];
      this.macaddress = this.sharedData['macAddress']
      if (this.sharedData != null) {
        // //inverter status is changing the get operation call with load
        // if (this.sharedData.inverterStatus !== this.inverterStatusVar) {
        //   this.inverterStatusVar = this.sharedData.inverterStatus;
        //   this.refreshOperation();
        // }

        if (this.sharedData.inverterStatus === "ON: Local Test Cycle" ||
          this.sharedData.inverterStatus === "ON: Remote test initiated") {
          this.isSelfTestStart = true;
        }
        else if (this.sharedData.inverterStatus === "NORMAL" || this.sharedData.inverterStatus === "LINE FAILED" || this.sharedData.inverterStatus === "ALARM: Last Test Failed") {
          this.isSelfTestStart = false;
          this.isSelfTestStartMsg=false;
        }
        else if (this.sharedData.inverterStatus === "OFFLINE") {
          this.isSelfTestStart = true;
        }
        //cmkick start - CM Kick Start available all the time for user with permission.
        // if (this.sharedData.majorAlarm === "ALARM - Loss of Communication") {
        //   this.cmKickStartBtn = true;
        // }
        // else {
        //   this.cmKickStartBtn = false;
        // }
        this.getOperationList(this.powerSupplyId);
        this.getRModeRealtimeStatus();
      }
    });

    this.user = "";
    this.time = "";
    //this.isSelfTestStart = false;

    this.columnDefs = [
      { headerName: 'IP', field: 'ipAddress', sortable: false },
      { headerName: 'MAC', field: 'macAddress', sortable: false },
      { headerName: 'Operation', field: 'operationPerformed' },
      { headerName: 'User ID', field: 'userName' },
      { headerName: 'Status', field: 'status' },
      { headerName: 'Date', field: 'createdDate', cellRenderer: "editRenderer", filter: true, sortable: true }
    ];

    this.context = { componentParent: this };
    this.defaultColDef = {
      filter: true, // set filtering on for all columns
      floatingFilter: true,
      sortable: true,
      resizable: true
    };
  }

  refreshOperation(){
    this.getOperationList(this.powerSupplyId);
    this.getRModeRealtimeStatus();
    this.ref.detectChanges();
  }
   getOperationList(powerSupplyId) {
     //localStorage.removeItem('TestStatus');
     this.spinner = true;
     this.powerSupplyOperationsSvc.getPowerSupplyOperationsList(powerSupplyId).subscribe(res => {
       this.processedData = this.processData(res);
       this.spinner = false;
       this.rowData = res;
       if (this.rowData !== null && this.rowData.length > 0) {
         this.isSelfTestStart = this.rowData[0].selfTestStart;
         this.isSelfTestStartMsg = this.isSelfTestStart;
         this.user = this.rowData[0].userName;
         this.time = this.rowData[0].testStartDate;
         this.lastRundate = this.rowData[0].lastRunDate;
         this.lastRunDate = new Date(this.lastRundate).toLocaleString();
         this.lastRunStatus = this.rowData[0].status;
         this.operationPerformed = this.rowData[0].operationPerformed;

        //Last run Status display based on the operationperformed - SELF_TEST, SCHEDULED REMOTE TEST
        //otherwise show -
        this.remotestatustimer = this.rowData[0]['lastRunDateHrMinSecTime'];
        //split the first value to display color
        if(this.remotestatustimer && (this.remotestatustimer != '' || this.remotestatustimer != 'null')){
          if(this.remotestatustimer.startsWith('FAILURE')){
            this.lastRunStatusTelemetry = 'FAILURE'
          }else if(this.remotestatustimer.startsWith('Start Failed - Test never started')){
            this.lastRunStatusTelemetry = 'Start Failed - Test never started';
          }else if(this.remotestatustimer.startsWith('Remote Test Initiated')){
            this.lastRunStatusTelemetry = 'Remote Test Initiated';
          }else if(this.remotestatustimer.startsWith('SUCCESS')){
            this.lastRunStatusTelemetry = 'SUCCESS';
          }
        }else{
        this.lastRunStatusTelemetry = null;
        }

         if(this.operationPerformed =='DOCSIS_RESET' || this.operationPerformed =='HMS_RESET' || this.operationPerformed =='SET_RMODE_OPERATION' || this.operationPerformed =='SCHEDULED REMOTE TEST'){
           this.remotestatus = this.rowData[0].status;
           //this.remotestatustimer ="Remote Self Test " + this.rowData[0].lastRunDateHrMinSecTime;
         } else {
         if(this.rowData[0].actualEndDate == null && this.sharedData.inverterStatusVal !== null && this.sharedData.inverterStatusVal == 1){
            //NORMAL - 1 but actualEndDate is null
           this.remotestatus = "Self Test Initiated";
           //this.remotestatustimer ="Remote Self Test " + this.rowData[0].lastRunDateHrMinSecTime;
         }
         if((this.rowData[0].actualEndDate == null && this.sharedData.inverterStatusVal !== null &&  this.sharedData.inverterStatusVal == 4)
         ||(this.rowData[0].actualEndDate == null && this.sharedData.inverterStatusVal !== null &&  this.sharedData.inverterStatusVal == 3)){
           //ON: Remote test initiated - 4
           //ON: Local Test Cycle - 3
           this.remotestatus = "Self Test Running";
           //this.remotestatustimer ="Remote Self Test " + this.rowData[0].lastRunDateHrMinSecTime;
         }
         if((this.rowData[0].actualEndDate != null && this.sharedData.inverterStatusVal !== null &&  this.sharedData.inverterStatusVal == 5)||
         this.rowData[0].actualEndDate != null && this.sharedData.inverterStatusVal !== null &&  this.sharedData.inverterStatusVal == 2){
           //ALARM: Last Test Failed - 5
           //LINE FAILED - 2
           this.remotestatus = "Self Test Failed";
           //this.remotestatustimer ="Remote Self Test " + this.rowData[0].lastRunDateHrMinSecTime;
         }
         if(this.rowData[0].actualEndDate != null && this.sharedData.inverterStatusVal !== null &&  this.sharedData.inverterStatusVal == 1){
           //NORMAL - 1
           if(this.lastRunStatus == 'FAILURE'){
             this.remotestatus = "FAILURE";
             //this.remotestatustimer ="Remote Self Test " + this.rowData[0].lastRunDateHrMinSecTime;
           }else{
             this.remotestatus = "Self Test Completed";
             //this.remotestatustimer ="Remote Self Test " + this.rowData[0].lastRunDateHrMinSecTime;
           }
         }
         if(this.rowData[0].actualEndDate != null && this.sharedData.inverterStatusVal == null) {
          this.remotestatus = this.rowData[0].status;
          //this.remotestatustimer ="Remote Self Test " + this.rowData[0].lastRunDateHrMinSecTime;
        }

         //localStorage.removeItem('TestStatus');
         //localStorage.setItem('TestStatus', this.remotestatus)
         if (this.sharedData.inverterStatus === "ON: Local Test Cycle" ||
           this.sharedData.inverterStatus === "ON: Remote test initiated" || this.lastRunStatus === 'Remote Test Initiated') {
           this.isSelfTestStart = true;
         } else {
            if(this.sharedData.inverterStatus === "OFFLINE") {
              this.isSelfTestStart = true;
            }else{
              this.isSelfTestStart = false;
            }
         }
        }
       }
     }, err => {
       if (err.status === 401) {
         this.router.navigate(['/unauthorized']);
       }
     });
   }


  // getOperationList(macaddress) {
  //   this.powerSupplyOperationsSvc.getPowerSupplyOperationsList(macaddress).subscribe(res => {
  //     this.processedData = this.processData(res);
  //     this.rowData = res;
  //     if (this.rowData !== null && this.rowData.length > 0) {
  //       this.isSelfTestStart = this.rowData[0].selfTestStart;
  //       this.isSelfTestStartMsg = this.isSelfTestStart;
  //       this.user = this.rowData[0].userName;
  //       this.time = this.rowData[0].testStartDate;
  //       this.lastRundate = this.rowData[0].lastRunDate;
  //       this.lastRunDate = new Date(this.lastRundate).toLocaleString();
  //       this.lastRunStatus = this.rowData[0].status;
  //       if (this.sharedData.inverterStatus === "ON: Local Test Cycle" ||
  //         this.sharedData.inverterStatus === "ON: Remote test initiated") {
  //         this.isSelfTestStart = true;
  //       } else {
  //         this.isSelfTestStart = false;
  //       }
  //     }
  //   }, err => {
  //     if (err.status === 401) {
  //       this.router.navigate(['/unauthorized']);
  //     }
  //   });
  // }
  getRModeRealtimeStatus(){
      this.powerSupplyService.getRealTimeRmodeStatus(this.macaddress).subscribe(res =>{
        this.RModeStatus=res.message;
      });
  }
  processData(rowData) {
    rowData.forEach(element => {
      element.testStartDate = element.testStartDate ? new Date(element.testStartDate).toLocaleString() : null;
      element.actualEndDate = element.actualEndDate ? new Date(element.actualEndDate).toLocaleString() : null;
      //split the | symbol and Result Column parse the API message field and just show in UI the text before pipe symbol |
      if(element.result && (element.result != '' || element.result != 'null')){
        let splitResult = element.result.split('|');
        if(splitResult != null){
          element.result = splitResult[0];
        }
      }
    });
    return rowData;
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    params.api.sizeColumnsToFit();
    params.api.sizeColumnsToFit();
    window.addEventListener("resize", function () {
      setTimeout(function () {
        params.api.sizeColumnsToFit();
      });
    });
  }

  openDialog($event: String) {
    this.action = $event;
    this.confirmDialog = this.dialog.open(SelftestconfirmDialogComponent, {
      data: {
        action: this.action,
        macAddress: this.macaddress,
        ip: this.ipAddress === undefined || null ? "" : this.ipAddress,
        powerSupplyId: this.powerSupplyId,
        cmts: this.cmts === undefined || null ? "" : this.cmts
      }
    });
  }

  moveToAlert() {
    // this.router.navigate(['/alerts'], { queryParams: { powerSupplyId: this.powerSupplyId } });
    if(this.powerSupplyId == null || this.powerSupplyId == undefined){
     var domain = location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : '');
     var url = domain + `/#/alerts` ;
     window.location.href = url;
    } else {
      var domain = location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : '');
      var url = domain + `/#/alerts?powerSupplyId=${this.powerSupplyId}` ;
      window.location.href = url;
    }
  }

  editTestDuration() {
    this.editTestDurationRendererComponent = this.dialog.open(EditTestDurationRendererComponent, {
      panelClass: 'my-centered-dialog',
      width: '512px',
      disableClose: true,
      data: {
        macAddress: this.macaddress,
        testDuration: this.sharedData.testDurationInMin
      }
    });
  }

}
